import { render, staticRenderFns } from "./InteractionInfo.vue?vue&type=template&id=791d748a&scoped=true&"
import script from "./InteractionInfo.vue?vue&type=script&lang=js&"
export * from "./InteractionInfo.vue?vue&type=script&lang=js&"
import style0 from "./InteractionInfo.vue?vue&type=style&index=0&id=791d748a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d748a",
  null
  
)

export default component.exports